export default "__VITE_ASSET__CWlVu7hZ__"